<template>
  <div>
    <div
      style="
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding-right: 2px;
        padding-left: 2px;
      "
      class="app"
    >
      <br />
      <div style="display: flex; justify-content: center; align-items: center">
        <img
          style="width: 200px; height: 100px"
          v-bind:src="
            'https://apppanterafood.com.br/DeliCenter/' +
            retornaContrato +
            '/logo/topo_deli.jpg'
          "
        />
      </div>
      <label
        style="
          display: flex;
          align-items: flex-start;
          margin-top: 5px;
          margin-bottom: 5px;
          background-color: #fff;
          color: #a9a9a9;
        "
        class="btn"
      >
        <font-awesome-icon
          style="padding-right: 5px"
          icon="utensils"
          size="lg"
        />
        <strong>Sobre</strong>
      </label>
      <form style="padding-left: 0.75rem">
        <div>
          <strong style="color: #a9a9a9">{{ estabelecimento.vl }}</strong>
          <br />
          {{ tipo_estabelecimento.vl }}
          <br />
          Endereco: {{ endereco.vl }}
          <br />
        </div>
        <!-- Whatsapp: {{whatsapp.vl}} -->
      </form>
      <label
        style="
          display: flex;
          align-items: flex-start;
          margin-top: 5px;
          margin-bottom: 5px;
          background-color: #fff;
          color: #a9a9a9;
        "
        class="btn"
      >
        <font-awesome-icon style="padding-right: 5px" icon="clock" size="lg" />
        <strong>Horário de funcionamento</strong>
      </label>
      <form style="padding-left: 0.75rem">
        <div>
          <li v-for="(horario, index) in horarios" :key="index">
            {{ retornaDias(index) }}
            <br />
            {{ horario.hr_inicial }} às {{ horario.hr_final }}
          </li>
        </div>
      </form>
      <label
        style="
          display: flex;
          align-items: flex-start;
          margin-top: 5px;
          margin-bottom: 5px;
          background-color: #fff;
          color: #a9a9a9;
        "
        class="btn"
      >
        <font-awesome-icon
          style="padding-right: 5px"
          icon="credit-card"
          size="lg"
        />
        <strong>Formas de pagamento</strong>
      </label>
      <form style="padding-left: 0.75rem">
        <div>
          <li v-for="(forma, index) in formas" :key="index">
            {{ forma.nm }}
          </li>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Horario from "../services/horario";
import Inis from "../services/inis";
import Bandeira from "../services/bandeira";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCreditCard } from "@fortawesome/free-solid-svg-icons";
import { faUtensils } from "@fortawesome/free-solid-svg-icons";
import { faClock } from "@fortawesome/free-solid-svg-icons";

library.add(faCreditCard);
library.add(faUtensils);
library.add(faClock);
export default {
  data() {
    return {
      horarios: [],
      formas: [],
      estabelecimento: [],
      whatsapp: [],
      endereco: [],
      tipo_estabelecimento: [],
    };
  },
  computed: {
    retornaContrato() {
      this.contrato = parseInt(localStorage.getItem("contrato"));

      return this.contrato;
    },
  },
  methods: {
    async listarHorarios() {
      var ativo = 1;
      await Horario.listarhorario(ativo).then((resposta) => {
        this.horarios = resposta.data;
        console.log(this.horarios);
      });
    },
    async listarForma() {
      await Bandeira.listarbandeiras().then((resposta) => {
        this.formas = resposta.data;
      });
    },
    async listarEstabelecimento() {
      var cd = "ESTABELECIMENTO";
      await Inis.listarInisCd(cd).then((resposta) => {
        this.estabelecimento = resposta.data[0];
      });
    },
    async listarWhatsapp() {
      var cd = "WHATSAPP";
      await Inis.listarInisCd(cd).then((resposta) => {
        this.whatsapp = resposta.data[0];
      });
    },
    async listarEndereco() {
      var cd = "ENDERECO";
      await Inis.listarInisCd(cd).then((resposta) => {
        this.endereco = resposta.data[0];
      });
    },
    async listarTipoEstabelecimento() {
      var cd = "TIPO_ESTABELECIMENTO";
      await Inis.listarInisCd(cd).then((resposta) => {
        this.tipo_estabelecimento = resposta.data[0];
      });
    },
    retornaDias(index) {
      var dias = this.horarios[index].dias
        .replace("seg", " Segunda")
        .replace("ter", " Terça")
        .replace("qua", " Quarta")
        .replace("qui", " Quinta")
        .replace("sex", " Sexta")
        .replace("sab", " Sábado")
        .replace("dom", " Domingo");
      return dias;
    },
  },
  mounted() {
    this.listarHorarios();
    this.listarForma();
    this.listarWhatsapp();
    this.listarEndereco();
    this.listarEstabelecimento();
    this.listarTipoEstabelecimento();
  },
};
</script>

<style scoped>
div,
form,
li {
  color: #a9a9a9;
}
</style>
